import { render } from "./AttendanceSummaryReport.vue?vue&type=template&id=6989c2c3"
import script from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"
export * from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__